import React, { useState, useEffect } from "react";
import { MainButton } from "../Buttons/MainButton/MainButton";
import playButton from "../../images/playButton.svg";
import { colors } from "../../constants/colors";
import { isEmail, number_to_price } from "./../../helper/common";
import { Modal } from "antd";
import { FirebaseRef } from "../../lib/firebase";
import serviceMail from "../../services/sendmail";
import { toast } from "react-toastify";
import { emailTemplateWaitingList } from '../../helper/emailTemplate'

export const EarlyAccess = () => {
  const [search, setSearch] = useState("");
  const [WaitingList, setWaitingList] = useState([]);

  useEffect(() => {
    getUserList();
  }, []);

  function getUserList() {
    const ref = FirebaseRef.child("/WaitingList");
    ref.once("value", (snapshot) => {
      const data = snapshot.val() || {};
      if (data && typeof data === "object") {
        let newData = [];
        Object.keys(data).forEach((key) => {
          if (data[key]) {
            newData.push({
              ...data[key],
              id: key,
            });
          }
        });
        const newArray = newData.reverse();
        setWaitingList(newArray);
      }
    });
  }

  function handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message,
    };
    serviceMail.sendMail(data).then(() => { });
  }
  function success() {
    const subject = `GenC Health message`;
    const content = emailTemplateWaitingList({ subject: 'Thank you!', subText: "You've been added to GenC Health waitlist" })
    handleSendMail(subject, content, "support@angelo.network", search);
    setSearch("");
    Modal.success({
      content: (
        <div className="early-modal">
          <div className="early-modal-title">Thank you!</div>
          <div className="early-modal-content">
            We have added your email address to signup queue.
          </div>
          <div className="early-modal-message">
            {WaitingList.length
              ? `${number_to_price(WaitingList.length)
              } People ahead of you`
              : ""}
          </div>
          <div className="early-modal-title">
            Interested in priority access ?
          </div>
          <div className="early-modal-content">
            Get early access by referring your friend, The more firend join, the
            sooner you'll get access
          </div>
        </div>
      ),
    });
  }

  function handleSubmit() {
    const Ref = FirebaseRef.push();
    const key = Ref.getKey();
    const ref = FirebaseRef.child(`/ WaitingList / ${key} `);
    ref
      .set({
        email: search,
      })
      .then((result) => {
        success();
      });
  }

  return (
    <section id="early-access" className="image-background early-access ">
      <div
        className="early-access-container"
        data-aos="fade-up"
        data-aos-delay="250"
      >
        <h3 className="p-2" style={{ color: colors.gencWhite }}>
          Circles iOS App for Your Family to Monitor Critical Health Alerts
        </h3>
        <div className="early-access-buttons">
          <input
            type="text"
            value={search}
            className="form-control"
            placeholder="Enter email address"
            onChange={(e) => {
              const { value } = e.target;
              setSearch(value);
            }}
          />
          <MainButton
            onClick={() => {
              const checkValide = isEmail(search);
              const index = WaitingList.findIndex(
                (item) => item.email === search
              );
              if (checkValide) {
                if (index === -1) {
                  handleSubmit();
                } else {
                  toast.warn("Email aldready exist");
                }
              } else {
                toast.warn("Email is invalid");
              }
            }}
            text="Get Early Access"
            style={{ height: "40px" }}
          />
        </div>
        <p className="p-2" style={{ color: colors.gencWhite }}>
          Watch the video <img src={playButton} alt="Play Button" />
        </p>
      </div>
    </section>
  );
};
